import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-csec",
  templateUrl: "./csec.component.html",
  styleUrls: ["./csec.component.css"],
})
export class CsecComponent implements OnInit {
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/csec/csec.component.ts